import { computed as c, useAttrs as i } from "vue";
import { trackListeners as a } from "@ds/tracking/tracking";
function L(s) {
  return { listeners: c(() => {
    const t = i(), n = Object.keys(t).filter((e) => e.match(/^on[A-Z]+/)).reduce((e, r) => {
      const o = `${r.charAt(2).toLocaleLowerCase()}${r.slice(3)}`;
      return { ...e, [o]: t[r] };
    }, {});
    return a({
      listeners: n,
      context: { ...t, ...s }
    });
  }) };
}
export {
  L as useTrackedListeners
};
